var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateFwd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#545454",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.47 4-.94.94L8.583 8 5.53 11.06l.94.94 4-4-4-4z",
    fill: "{fill}"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateFwd);
export default __webpack_public_path__ + "static/media/navigateFwd.167d48abb11370f58f6186a02d80bfeb.svg";
export { ForwardRef as ReactComponent };